import envConfig from '../config/config';
import logger from './logger';
import { EXPIRED_URL_THROWN_MESSAGE } from '../screens/CreateAccount/create-account';

export const EXPIRED_URL_ERROR_MESSAGE = 'Token expired';

export async function CreateAccountRequest(email) {
  await fetch(`${envConfig.apps.providerAccount}/v1/provisioning/request-account/${email}`, {
    method: 'POST',
  }).catch((error) => {
    logger.error(error, {
      context: {
        email,
        message: 'Error submitting create account request',
      },
    });
    throw new Error('Error submitting create account request');
  });
}

export async function AttemptAutoProvisioning(token) {
  await fetch(`${envConfig.apps.providerAccount}/v1/provisioning/attempt-provisioning`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(async (resp) => {
      if (resp.status !== 201) {
        const parsedResp = await resp.json();
        if (parsedResp.message === EXPIRED_URL_ERROR_MESSAGE) {
          throw new Error(EXPIRED_URL_THROWN_MESSAGE);
        } else {
          throw new Error('Bad Request');
        }
      }
    })
    .catch((err) => {
      logger.error(err);
      throw new Error(err.message);
    });
}

export async function CreateNotetakerAccountRequest(data) {
  const { firstName, lastName, contactType, email, zipCode, institutionName, npi } = data;

  const response = await fetch(`${envConfig.apps.providerAccount}/v1/provisioning/notetaker`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      firstName,
      lastName,
      email,
      contactType,
      zipCode,
      institutionName,
      npi,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error creating notetaker account');
  }
}
